import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useAppStore } from '../../stores/useAppStore';
import { Logo } from '../Header/Header';

export function Footer() {
  const { t } = useTranslation();
  const { settings } = useAppStore();
  const { pathname } = useLocation();
  const currentYear = new Date().getFullYear();

  const botLink = settings['bot_link'] || '#';
  const supportLink = settings['support_link'] || '#';
  const termsLink = settings['terms_link'] || '/terms';
  const siteName = settings['site_name'] || 'RubExchange';
  const companyName = settings['company_name'] || '';
  const companyAddress = settings['company_address'] || '';
  // Якоря главной: на других страницах ведём на главную
  const anchor = (id: string) => (pathname === '/' ? `#${id}` : `/#${id}`);

  return (
    <footer className="rx-footer">
      <div className="rx-footer__inner">
        <div className="rx-footer__brand">
          <Logo />
          <p className="rx-footer__about">
            Покупка и продажа USDT за рубли: оплата по СБП, выплата на карту.
          </p>
          <ul className="rx-footer__pay" aria-label="Способы оплаты и сети">
            <li><img src="/sbp.svg" alt="СБП" className="rx-footer__sbp" /></li>
            <li><img src="/usdt.svg" alt="" /> USDT</li>
            <li><img src="/tron.svg" alt="" /> TRC-20</li>
          </ul>
        </div>

        <nav className="rx-footer__col" aria-label="Сервис">
          <span className="rx-footer__heading">Сервис</span>
          <a href={anchor('exchange')} className="rx-footer__link">Купить и продать USDT</a>
          <a href={anchor('how')} className="rx-footer__link">Как это работает</a>
          <a href={anchor('faq')} className="rx-footer__link">Частые вопросы</a>
          <a href="/account" className="rx-footer__link">Личный кабинет</a>
        </nav>

        <nav className="rx-footer__col" aria-label="Документы">
          <span className="rx-footer__heading">Документы</span>
          <a href={termsLink} className="rx-footer__link">{t('footer.userAgreement')}</a>
        </nav>

        <nav className="rx-footer__col" aria-label="Связь">
          <span className="rx-footer__heading">Связь</span>
          {supportLink !== '#' && (
            <a href={supportLink} target="_blank" rel="noopener noreferrer" className="rx-footer__link">
              {t('footer.support')} в Telegram
            </a>
          )}
          {botLink !== '#' && (
            <a href={botLink} target="_blank" rel="noopener noreferrer" className="rx-footer__link">
              {t('footer.telegramBot')}
            </a>
          )}
          <span className="rx-footer__note">Отвечаем 24/7</span>
        </nav>

        <div className="rx-footer__bottom">
          <span>© {siteName} {currentYear}</span>
          {(companyName || companyAddress) && (
            <div className="rx-footer__company">
              {companyName && <div>{companyName}</div>}
              {companyAddress && <div>{companyAddress}</div>}
            </div>
          )}
        </div>
      </div>

      {/* Крупный логотип внизу, обрезан краем страницы */}
      <div className="rx-footer__wordmark" aria-hidden="true">RubExchange</div>
    </footer>
  );
}
